!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? r(exports, require("react"), require("@material-ui/core/TextField"), require("formik"), require("@material-ui/core")) : "function" == typeof define && define.amd ? define(["exports", "react", "@material-ui/core/TextField", "formik", "@material-ui/core"], r) : r((e = e || self).field = {}, e.React, e.TextField, e.formik, e.core);
}(this, function (e, r, t, n, o) {
  "use strict";

  var l = "default" in r ? r.default : r;
  t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;

  var _a = function a() {
    return (_a = Object.assign || function (e) {
      for (var r, t = 1, n = arguments.length; t < n; t++) for (var o in r = arguments[t]) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);

      return e;
    }).apply(this, arguments);
  };

  function i(e, r) {
    var t = {};

    for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;

      for (n = Object.getOwnPropertySymbols(e); o < n.length; o++) r.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (t[n[o]] = e[n[o]]);
    }

    return t;
  }

  var u = function u(e) {
    var t = e.margin,
        n = e.Icon,
        i = e.children,
        u = r.useMemo(function () {
      return "normal" === t ? {
        marginTop: 16,
        marginBottom: 8
      } : "dense" === t ? {
        marginTop: 8,
        marginBottom: 4
      } : {};
    }, [t]);
    return l.createElement(o.Grid, {
      container: !0,
      spacing: 0,
      direction: "row",
      alignItems: "flex-end"
    }, l.createElement(o.Grid, {
      item: !0,
      style: _a({
        marginRight: 9
      }, u)
    }, l.createElement(n, null)), l.createElement(o.Grid, {
      style: {
        flexGrow: 1
      },
      item: !0
    }, i));
  },
      c = function c(e) {
    var n = e.shrink,
        u = e.onChange,
        c = e.value,
        s = e.field,
        m = e.helper,
        f = e.hideErrors,
        d = e.errorMessage,
        p = e.focused,
        h = e.helperText,
        v = e.fullWidth,
        g = e.InputProps,
        y = e.placeholder,
        E = e.style,
        b = e.inputRef,
        F = i(e, ["shrink", "onChange", "value", "field", "helper", "hideErrors", "errorMessage", "focused", "helperText", "fullWidth", "InputProps", "placeholder", "style", "inputRef"]),
        w = !!(n || p || c || y && d),
        O = F.variant || "filled",
        x = r.useMemo(function () {
      return g && g.startAdornment;
    }, [g]),
        I = r.useRef(null),
        k = b || r.useRef(null),
        C = r.useState(0),
        T = C[0],
        P = C[1];
    r.useLayoutEffect(function () {
      I && I.current && P(I.current.offsetWidth);
    }, [I]);

    var j,
        S = function S() {
      k && k.current && k.current.focus();
    },
        R = (j = w || "filled" !== O ? 0 : -16, o.makeStyles(function (e) {
      return o.createStyles({
        inputAdornment: {
          marginTop: j,
          transition: e.transitions.create("margin-top", {
            easing: e.transitions.easing.easeInOut,
            duration: e.transitions.duration.shortest
          })
        }
      });
    })()),
        M = x ? l.createElement("span", {
      onClick: function onClick() {
        return S();
      },
      onDoubleClick: function onDoubleClick() {
        k && k.current && (S(), k.current.select());
      },
      className: R.inputAdornment
    }, x) : void 0,
        B = w ? {
      shrink: !0
    } : x ? {
      shrink: !1,
      style: {
        marginLeft: T
      }
    } : void 0,
        W = r.useCallback(function (e) {
      if (u) return u(e), void s.onChange(e);
      s.onChange(e);
    }, [u]),
        L = _a(_a({}, s), {
      onChange: W
    }),
        q = _a(_a(_a({}, F), L), {
      id: s.name,
      name: s.name,
      placeholder: y || "",
      InputProps: _a(_a({}, g), {
        startAdornment: M
      }),
      inputRef: k,
      value: c,
      inputProps: {
        "data-testid": s.name
      },
      variant: O
    });

    return l.createElement("div", {
      style: E
    }, x ? l.createElement("div", {
      style: {
        position: "absolute",
        display: "inline-block",
        opacity: 0
      },
      ref: I
    }, x) : null, d && m ? l.createElement(o.FormControl, {
      fullWidth: v
    }, l.createElement(t, _a({}, q, {
      InputLabelProps: B,
      error: !0
    })), d ? l.createElement(o.FormHelperText, {
      style: {
        whiteSpace: "pre-wrap",
        marginTop: 0
      },
      error: !0
    }, d) : null) : !d || m || f ? l.createElement(o.FormControl, {
      fullWidth: v
    }, l.createElement(t, _a({}, q, {
      error: !!d,
      InputLabelProps: B
    })), h ? l.createElement(o.FormHelperText, {
      style: {
        whiteSpace: "pre-wrap",
        marginTop: 0
      }
    }, h) : null) : l.createElement(o.FormControl, {
      fullWidth: v
    }, l.createElement(t, _a({}, q, {
      InputLabelProps: {
        shrink: w
      },
      error: !0,
      label: e.label ? d : void 0,
      placeholder: e.placeholder ? e.placeholder : e.label ? "" + e.label : void 0
    })), h ? l.createElement(o.FormHelperText, {
      style: {
        whiteSpace: "pre-wrap",
        marginTop: 0
      }
    }, h) : null));
  },
      s = function s(e) {
    var t = e.field,
        o = e.form,
        s = e.valueFn,
        m = e.Icon,
        f = e.iconFocusedColor,
        d = e.margin,
        p = e.onBlur,
        h = i(e, ["field", "form", "valueFn", "Icon", "iconFocusedColor", "margin", "onBlur"]),
        v = n.getIn(o.errors, t.name),
        g = n.getIn(o.touched, t.name),
        y = r.useState(!1),
        E = y[0],
        b = y[1],
        F = t.value,
        w = i(t, ["value"]),
        O = r.useCallback(function (e) {
      return s ? s(e) : void 0 !== e ? e : "";
    }, [s])(F),
        x = _a(_a({}, w), {
      onFocus: function onFocus(e) {
        t.onFocus && t.onFocus(e), b(!0);
      },
      onBlur: function onBlur(e) {
        p && p(e), t.onBlur(e), b(!1);
      }
    });

    return l.createElement(l.Fragment, null, m ? l.createElement(u, {
      margin: d,
      Icon: function Icon() {
        return g && v ? l.createElement(m, {
          color: "error"
        }) : l.createElement(m, {
          color: E && !f ? "primary" : void 0,
          style: E ? {
            color: f
          } : void 0
        });
      }
    }, l.createElement(c, _a({
      focused: E,
      margin: d,
      errorMessage: g ? v : "",
      value: O,
      field: x
    }, h))) : l.createElement(c, _a({
      focused: E,
      margin: d,
      errorMessage: g ? v : "",
      value: O,
      field: x
    }, h)));
  },
      m = function m(e) {
    var r = e.slow,
        t = e.name,
        o = e.validate,
        u = i(e, ["slow", "name", "validate"]);
    return r ? l.createElement(n.Field, {
      name: t,
      validate: o
    }, function (e) {
      var r = e.field,
          n = e.form;
      return l.createElement(s, _a({
        name: t,
        field: r,
        form: n
      }, u));
    }) : l.createElement(n.FastField, {
      name: t,
      validate: o
    }, function (e) {
      var r = e.field,
          n = e.form;
      return l.createElement(s, _a({
        name: t,
        field: r,
        form: n
      }, u));
    });
  },
      f = s;

  e.Field = m, e.RawField = f, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});